import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class StoreSelectorStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			${Text.CSS}

			:host {
				display: block;
			}

			.container {
				position: relative;
				display: block;
			}

			.linkContainer {
				display: flex;
				align-items: flex-start;
				color: ${color.text.default};
			}

			.storeAvailabilityContainer {
				display: flex;
				flex-wrap: wrap;
				margin-inline-start: ${spacing.space50 / 16}rem;
			}

			.availabilityLabel {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				min-height: ${spacing.space150 / 16}rem;
			}

			.restock,
			.captionText {
				width: 100%;
				color: ${color.text.lightest};
				min-height: ${spacing.space150 / 16}rem;
			}

			skapa-icon {
				flex-shrink: 0;
				width: ${spacing.space150 / 16}rem;
				height: ${spacing.space150 / 16}rem;
				color: ${color.icon.default};
			}

			kompis-hyperlink {
				white-space: normal;
			}

			skapa-status.status-hidden {
				--size: 0;
			}
		`;
    }
}
//# sourceMappingURL=StoreSelectorStyle.js.map